import { createGlobalStyle, css } from 'styled-components';
import localFont from 'next/font/local';
import theme from './theme';

//! Color Generator
function colorGenerator() {
	const colorsArr = Object.keys(theme.colors);

	let colorVariable = '';

	for (let i = 0; i < colorsArr.length; i++) {
		colorVariable += `--${colorsArr[i]}: ${theme.colors[colorsArr[i]]};`;
	}

	return colorVariable;
}

//! Fonts - Optimized to use only woff2 for better performance
export const montserrat_arm = localFont({
	src: [
		{
			path: '../../public/fonts/Montserratarm-Light.woff2',
			weight: '300',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Regular.woff2',
			weight: '400',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Medium.woff2',
			weight: '500',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-SemiBold.woff2',
			weight: '550',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Bold.woff2',
			weight: '600',
			style: 'normal',
		},
	],
	display: 'swap',
	preload: true,
	fallback: ['system-ui', 'arial'],
});

const Variables = createGlobalStyle`${css`
	:root {
		/* //! Container */
		--core_contPaddingLR: var(--contPaddingLR);
		--core_sectionDistance: var(--sectionDistance);

		/* //! Fonts */
		--montserrat_arm: ${montserrat_arm.style.fontFamily};

		/* //! Transition */
		--trTime: 0.3s;

		/* //! Line Heights */
		--lineHeightM: 1.4;
		--lineHeightL: 1.6;

		/* //! Colors */
		${colorGenerator()};

		/* //! Grid Column Distance */
		--colPadding: calc(var(--gutter) / 2);
	}

	/* //! 2560 */
	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeXL}) {
		:root {
			--h1: 64px;
			--h2: 48px;
			--h3: 56px;
			--h4: 48px;

			--h5: 40px;
			--h6: 32px;
			--h7: 28px;

			--p1: 20px;
			--p2: 18px;
			--input: 18px;
			--header_open: 16px;

			/* //! Global Variables */
			/* --contPaddingLR: var(--sp32x); */
			--contPaddingLR: var(--sp40x);
			--gutter: var(--sp4x);
			--sectionDistance: 180px;
			--headerFixedHeight: 136.39px;

			--titleContentDistance: var(--sp8x);
			--pageDistance: var(--sp12x);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeL}) {
		:root {
			--h1: 56px;
			--h2: 40px;
			--h3: 56px;
			--h4: 32px;

			--h5: 32px;
			--h6: 28px;
			--h7: 24px;

			--p1: 18px;
			--p2: 16px;
			--input: 16px;
			--header_open: 14px;

			/* //! Global Variables */
			/* --contPaddingLR: var(--sp24x); */
			--contPaddingLR: var(--sp30x);
			--gutter: var(--sp3x);
			--sectionDistance: var(--sp20x);
			--headerFixedHeight: 127.59px;

			--titleContentDistance: var(--sp6x);
			--pageDistance: var(--sp10x);
		}
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeM}) {
		:root {
			--h1: 40px;
			--h2: 40px;
			--h3: 40px;
			--h4: 32px;
			--h5: 28px;
			--h6: 24px;
			--h7: 20px;
			--p1: 16px;
			--p2: 14px;
			--input: 16px;
			--header_open: 14px;

			/* //! Global Variables */
			/* --contPaddingLR: var(--sp13x); */
			--contPaddingLR: var(--sp20x);
			--gutter: var(--sp3x);
			--sectionDistance: var(--sp15x);
			--headerFixedHeight: 103.59px;

			--titleContentDistance: var(--sp5x);
			--pageDistance: var(--sp8x);
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeS}) {
		:root {
			--h1: 40px;
			--h2: 40px;
			--h3: 40px;
			--h4: 32px;
			--h5: 28px;
			--h6: 18px;
			--h7: 18px;
			--p1: 16px;
			--p2: 14px;
			--input: 16px;
			--header_open: 14px;

			/* //! Global Variables */
			/* --contPaddingLR: var(--sp9x); */
			--contPaddingLR: var(--sp12x);
			--gutter: var(--sp2-5x);
			--sectionDistance: var(--sp13x);
			--headerFixedHeight: 95.59px;

			--titleContentDistance: var(--sp4x);
			--pageDistance: var(--sp7x);
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSize}) {
		:root {
			--h1: 40px;
			--h2: 32px;
			--h3: 32px;
			--h4: 28px;
			--h5: 24px;
			--h6: 16px;
			--h7: 16px;
			--p1: 16px;
			--p2: 14px;
			--input: 16px;
			--header_open: 14px;

			/* //! Global Variables */
			/* --contPaddingLR: var(--sp7x); */
			/* --contPaddingLR: var(--sp12x); */
			--contPaddingLR: var(--sp10x);
			--gutter: var(--sp2-5x);
			--sectionDistance: var(--sp11x);
			--headerFixedHeight: 83.59px;

			--titleContentDistance: var(--sp3x);
			--pageDistance: var(--sp5x);
		}
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeX}) {
		:root {
			--h1: 32px;
			--h2: 32px;
			--h3: 28px;
			--h4: 24px;
			--h5: 20px;
			--h6: 16px;
			--h7: 16px;
			--p1: 14px;
			--p2: 14px;
			--input: 16px;
			--header_open: 14px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp5x);
			--gutter: var(--sp2x);
			--sectionDistance: var(--sp9x);
			--headerFixedHeight: 79.59px;

			--titleContentDistance: var(--sp3x);
			--pageDistance: var(--sp4x);
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeS}) {
		:root {
			--h1: 32px;
			--h2: 32px;
			--h3: 28px;
			--h4: 24px;
			--h5: 20px;
			--h6: 16px;
			--h7: 16px;
			--p1: 14px;
			--p2: 14px;
			--input: 16px;
			--header_open: 14px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp3x);
			--gutter: var(--sp2x);
			--sectionDistance: var(--sp8x);
			--headerFixedHeight: 71.59px;

			--titleContentDistance: var(--sp2-5x);
			--pageDistance: var(--sp4x);
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		:root {
			--h1: 28px;
			--h2: 24px;
			--h3: 20px;
			--h4: 20px;
			--h5: 18px;
			--h6: 16px;
			--h7: 16px;
			--p1: 14px;
			--p2: 14px;
			--input: 16px;
			--header_open: 14px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp2x);
			--gutter: var(--sp1x);
			--sectionDistance: var(--sp7x);
			--headerFixedHeight: 71.59px;

			--titleContentDistance: var(--sp2-5x);
			--pageDistance: var(--sp4x);
		}
	}
`}`;

export default Variables;
